import React, { useContext } from 'react'

import { Link as TanStackLink } from '@tanstack/react-router'

import { DigitalProductContext } from '@/shared/contexts/DigitalProductContext'

const isExternal = (href: string) =>
  /^(https?:\/\/|\/\/|mailto:|tel:)/.test(href)

type AnchorProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>

type InternalLinkProps = AnchorProps & {
  href: string
  children?: React.ReactNode
}

export const Link = React.forwardRef<HTMLAnchorElement, InternalLinkProps>(
  ({ href, children, ...props }, ref) => {
    const digitalProductCtx = useContext(DigitalProductContext)
    const basePathWithId = digitalProductCtx?.basePathWithId ?? ''

    const finalHref =
      typeof href === 'string' && !isExternal(href)
        ? `${basePathWithId}${href.replace(basePathWithId, '')}`
        : href

    if (isExternal(String(finalHref))) {
      return (
        <a ref={ref} href={String(finalHref)} {...props}>
          {children}
        </a>
      )
    }

    return (
      <TanStackLink ref={ref} to={String(finalHref)} {...props}>
        {children}
      </TanStackLink>
    )
  }
)

Link.displayName = 'Link'
